/** Product capability shown on the sign-in editorial panel (no fabricated metrics). */
export interface StudioCapability {
  label: string;
  detail: string;
}

export const HERO_IMG = '/logo.jpg';

/** Verified Jewelitt tools — each maps to a live feature in the app. */
export const STUDIO_CAPABILITIES: StudioCapability[] = [
  {
    label: '3D Configurator',
    detail: 'Photoreal rings clients reconfigure live — metal, stone, model',
  },
  {
    label: 'Client Lookbooks',
    detail: 'Share a link, collect comments & sign-off — no client login',
  },
  {
    label: 'Bulk Render',
    detail: '4K stills & 360° turntables at 300 DPI, on our cloud or your S3',
  },
];

/** Factual platform notes (no unverified compliance badges). */
export const PLATFORM_NOTES: string[] = [
  'Optional two-factor authentication',
  'Workspace-scoped assets, team roles & access',
  'Bring your own S3 + CloudFront storage',
];
